<template>
	<v-row>
		<v-col>
			<div class="d-flex align-center">
				<h3 class="title grey--text text--darken-4">{{ title }}</h3>
			</div>
		</v-col>
	</v-row>
</template>

<script>
	/**
	 * @module Breadcrumbs
	 *
	 * @vue-prop {string} title - Set title
	 */

	export default {
		name: 'Breadcrumbs',
		props: {
			title: {
				type: String,
				required: true,
			},
		},
	};
</script>
